// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const ar: ChromeTranslations = {
  'nav.nextPage': '← الصفحة التالية',
  'nav.previousPage': 'الصفحة السابقة →',
  'nav.continueToLevel': '← متابعة إلى المستوى',
  'nav.backToMenu': '← العودة إلى القائمة',
  'howto.page': 'صفحة {n} من {total}',
  'options.title': 'الخيارات',
  'ui.language': 'اللغة',
};
